module.exports = "//static.hsappstatic.net/LoginUI/static-1.16097/img/passkey-logo.svg"